import { z } from "zod";

export const ipRangeSchema = z.object({
  ipAddress: z.string().ip({ version: "v4" }),
  cidrPrefix: z.number().min(0).max(32),
});

export type IpRangeSchema = z.infer<typeof ipRangeSchema>;
